export default (toolName : string, toolId : string) => {
  window.TRACKING_TOOLS.set(toolName, {
    required_cookie_settings: toolName,
    initTracking () {
      window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || []
      window._linkedin_data_partner_ids.push(toolId)
      const s = document.getElementsByTagName('script')[0]
      const b = document.createElement('script')
      b.type = 'text/javascript'
      b.async = true
      b.src = 'https://snap.licdn.com/li.lms-analytics/insight.min.js'
      s.parentNode?.insertBefore(b, s)
    },
  })
}
